import { Link, useLocation } from 'react-router-dom';
import { MapPinOff } from 'lucide-react';
import { EmptyState } from '@/components/EmptyState';
import { PageHeader } from '@/components/PageHeader';
import { Button } from '@/components/ui/button';
import { navSectionFor, sectionBreadcrumbItems } from '@/navigation/section-breadcrumbs';

/**
 * An address the app has no page for: said inside the app, with links to Home and the
 * nearest section, rather than a redirect to Home that makes Back bounce. The catch-all route in
 * `app.tsx` shows it; a record that doesn't exist is RecordPageState's job.
 */
export function NotFoundPage({ header = true }: { header?: boolean }) {
  const { pathname } = useLocation();
  const section = navSectionFor(pathname);
  return (
    <div className="space-y-6">
      {header ? <PageHeader breadcrumbItems={sectionBreadcrumbItems(pathname)} recordTitle="Page not found" /> : null}
      <EmptyState
        icon={<MapPinOff className="size-5" />}
        title="There's no page at this address"
        description="The link may be mistyped, or the page has moved."
      >
        <div className="flex flex-wrap justify-center gap-2">
          {section ? (
            <Button asChild size="sm">
              <Link to={section.path}>Go to {section.label}</Link>
            </Button>
          ) : null}
          <Button asChild size="sm" variant={section ? 'outline' : 'default'}>
            <Link to="/projects">Go to Projects</Link>
          </Button>
        </div>
      </EmptyState>
    </div>
  );
}
